// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-toggle:after{content:normal}.block{margin-bottom:20px}.product-best-sellers{background:#ededed;display:flex;flex-direction:column;justify-content:space-between;margin-bottom:20px;width:175px}.product-best-sellers__panel{flex:0 1 100%;text-align:center}.product-best-sellers__heading{border-bottom:1px solid #dee2e6;font-weight:700;margin:0;padding:10px 0;text-transform:uppercase}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
